<template>
  <div class="admin-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">{{ $t('homeTitle') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('admin.list') }}</el-breadcrumb-item>
    </el-breadcrumb>

    <snowflake-search-list context="admin" :service="adminService">
      <template slot="tableRows">

        <!-- ID -->
        <el-table-column prop="id" :label="$t('admin.id')" width="80" sortable="custom"></el-table-column>

        <!-- Name -->
        <el-table-column prop="name" :label="$t('admin.name')" :show-overflow-tooltip="true" sortable="custom">
          <template slot-scope="scope">
            <span>{{ `${scope.row.firstName} ${scope.row.lastName}` }}</span>
          </template>
        </el-table-column>

        <!-- E-mail -->
        <el-table-column prop="email" :label="$t('admin.email')" :show-overflow-tooltip="true" sortable="custom">
        </el-table-column>

        <!-- Roles -->
        <el-table-column :label="$t('admin.roles')">
          <template slot-scope="scope">
            <el-tag v-for="role in scope.row.roles" :key="role" size="mini" class="role">{{ role }}</el-tag>
          </template>
        </el-table-column>

      </template>
    </snowflake-search-list>

  </div>
</template>

<script>
import AdminService from '@/services/AdminService';
import SnowflakeSearchList from '@/components/list/SearchList.vue';

export default {
  name: 'admin-list',
  components: {
    SnowflakeSearchList,
  },
  data() {
    return {
      adminService: AdminService,
    };
  },
};
</script>

<style lang="scss" scoped>
.admin-list {
  .role {
    margin-right: 5px;
  }
}
</style>
